// extracted by mini-css-extract-plugin
export default {"comments":"worksite-comments_comments__QId3d","col":"worksite-comments_col__BqApd","notes":"worksite-comments_notes__SzLcw"};